<div
  [class]="class"
  class="flex flex-row items-center h-8 min-w-0 max-w-[190px]"
>
  <div
    *ngIf="imageUrl"
    class="flex justify-center items-center w-8 h-8 mr-2 rounded-full overflow-hidden flex-shrink-0"
  >
    <img src="{{ imageUrl }}" class="h-full w-full object-cover" />
  </div>
  <div
    class="flex justify-center items-center w-8 h-8 p-2 rounded-full flex-shrink-0"
    [ngStyle]="{ 'background-color': randomColor(name) }"
    [ngClass]="!isCollapsed ? 'mr-2' : 'mr-0'"
    *ngIf="!imageUrl"
  >
    <span class="text-[white]">{{ getInitials(name) }}</span>
  </div>

  <div *ngIf="!isCollapsed" class="flex flex-col min-w-0">
    <div
      class="text-[#EFF3FA] mr-5 text-sm truncate"
      [customTooltip]="name"
      [tooltipOnlyIfTruncated]="true"
      [tooltipPosition]="tooltipPosition"
    >
      {{ name }}
    </div>
    <div
      class="text-xs text-[#9BA9C4] truncate"
      [customTooltip]="email"
      [tooltipOnlyIfTruncated]="true"
      [tooltipPosition]="tooltipPosition"
    >
      {{ email }}
    </div>
  </div>
</div>
